import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredSlugs = [
  'ruhe-youya-rang-jiejie-jieshao-pengyou',
  'kuajuan-shejiao-wuge-faze',
  'shouyin-xiaoying-diyi-yinxiang',
  'changqi-renmai-weihu-sanda-mijue',
  'neixiangzhe-shejiao-tuwei',
  'cong-jiejie-guimi-dao-nide-guiren',
];

const featuredArticles = articles.filter((a) => featuredSlugs.includes(a.slug));

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              编辑团队为你精选的高质量社交指南
            </p>
          </div>
          <Link
            to="/category/jiejie-pengyouquan"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-white/90 text-foreground-800 text-xs font-medium rounded-full">
                  {article.categoryName}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-2 flex-wrap">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-background-100 text-foreground-600 text-xs rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}